<script setup>
import { onKeyStroke, useScrollLock } from '@vueuse/core'
import { inject, onMounted, provide, ref, watch } from 'vue'

const open = defineModel('open', { type: Boolean, default: false })
const isWindowScrollLocked = useScrollLock(window, false)

watch(open, (open) => { isWindowScrollLocked.value = open }, { immediate: true })

const breakpoints = inject('breakpoints')
const isInMobileNavBp = ref(breakpoints.smaller('lg'))
watch(isInMobileNavBp, (isSmaller) => {
    if (!isSmaller && open.value) {
        close()
    }
}, { immediate: true })
onKeyStroke(['Escape'], (e) => {
    if (!open.value) { return }

    e.preventDefault()
    close()
})

function toggle() { open.value = !open.value; }
function close () { open.value = false, isWindowScrollLocked.value = false }
provide('main-navigation', { close, toggle, open })
</script>

<template>
    <slot v-bind="{ toggle, close, open }"></slot>
</template>

<style lang="scss">
</style>

